import { composeIO } from 'react-compose-io'
import { formularioRegraIO } from './FormularioRegra.IO'
import { FormularioRegraView } from './FormularioRegra.View'

export const FormularioRegra = composeIO(FormularioRegraView, formularioRegraIO)
